import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import './LandingView.css';

const LandingView: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const { t } = useTranslation();

    // Redirect authenticated users to their appropriate view
    if (isAuthenticated) {
        return null; // This will be handled by routing
    }

    return (
        <div className="container">
            <div className="landing-page">
                <div className="hero-section">
                    <h1>Welcome to LuLarge</h1>
                    <p className="hero-subtitle">
                        Your comprehensive platform for bond analytics and investment research.
                        Explore advanced tools, detailed analytics, and comprehensive data
                        to make informed investment decisions.
                    </p>
                </div>

                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon">
                            <span className="material-icons">search</span>
                        </div>
                        <h3>Advanced Bond Search</h3>
                        <p>Search through our comprehensive bond database with advanced filtering capabilities and detailed analytics.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">
                            <span className="material-icons">analytics</span>
                        </div>
                        <h3>Comprehensive Analytics</h3>
                        <p>Access detailed bond analytics, performance metrics, historical data trends, and comprehensive reports.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">
                            <span className="material-icons">build</span>
                        </div>
                        <h3>Professional Tools</h3>
                        <p>Leverage professional-grade tools for portfolio management, risk assessment, and investment optimization.</p>
                    </div>

                    <div className="feature-card">
                        <div className="feature-icon">
                            <span className="material-icons">business_center</span>
                        </div>
                        <h3>Investment Research</h3>
                        <p>Access comprehensive research reports, market analysis, and expert recommendations to guide your decisions.</p>
                    </div>
                </div>

                <div className="cta-section">
                    <h2>Explore LuLarge Today</h2>
                    <p>Start by exploring our sample data to see what LuLarge can offer, or get started with a free account.</p>

                    <div className="cta-buttons">
                        <Link to="/bonds" className="secondary-button">
                            <span className="material-icons button-icon">visibility</span>
                            View Example Data
                        </Link>
                        <Link to="/benefits" className="primary-button">
                            <span className="material-icons button-icon">rocket_launch</span>
                            {t('auth.getStartedNow')}
                        </Link>
                    </div>

                    <div className="cta-divider"></div>

                    <div className="features-preview">
                        <h3>What you'll discover:</h3>
                        <div className="preview-items">
                            <div className="preview-item">
                                <span className="material-icons check">check_circle_outline</span>
                                Comprehensive bond database
                            </div>
                            <div className="preview-item">
                                <span className="material-icons check">check_circle_outline</span>
                                Advanced search capabilities
                            </div>
                            <div className="preview-item">
                                <span className="material-icons check">check_circle_outline</span>
                                Professional analytics tools
                            </div>
                            <div className="preview-item">
                                <span className="material-icons check">check_circle_outline</span>
                                Real-time market data
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingView;